// extracted by mini-css-extract-plugin
export default {"header":"header_header__A7NEZ","header_left":"header_header_left__rYu5I","header_left_logo":"header_header_left_logo__bMsfA","header_right_close":"header_header_right_close__yJY-u"};